import { useState } from "react";
import { FaStar } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { resetCallState } from "../features/call/callSlice";
import { updateUser } from "../features/auth/authSlice";
import { RateThisCall, GetWalletAmount } from "../services/api";

export default function CallRating() {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const dispatch = useDispatch();

  const call = useSelector((state) => state?.call);

  const handleSubmit = async () => {
    if (rating === 0) return;

    const rateCallRes = await RateThisCall({
      callId: call?.callId,
      rating: rating
    });

    dispatch(resetCallState());

    GetWalletAmount()
      .then((res) => {
        dispatch(updateUser({
          walletBalance: res.data.walletBalance,
        }));
      })
      .catch((err) => {
        console.log(err)
      });
  };

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">

      {/* CARD */}
      <div className="bg-[#121212] rounded-2xl p-6 w-[90%] max-w-sm text-center shadow-xl">

        <h2 className="text-white text-lg font-semibold mb-2">
          Rate this call
        </h2>

        <p className="text-gray-400 text-sm mb-4">
          Your feedback helps improve experience
        </p>

        {/* STARS */}
        <div className="flex justify-center gap-2 mb-6">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={32}
              className={`cursor-pointer transition transform ${(hover || rating) >= star
                ? "text-yellow-400 scale-110"
                : "text-gray-600"
                }`}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
            />
          ))}
        </div>

        {/* SUBMIT */}
        <button
          onClick={handleSubmit}
          disabled={rating === 0}
          className={`w-full py-2 rounded-full text-sm font-semibold transition ${rating === 0
            ? "bg-gray-700 text-gray-400 cursor-not-allowed"
            : "bg-red-500 text-white"
            }`}
        >
          Submit Rating
        </button>

      </div>
    </div>
  );
}